var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingcalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.942,
    height: 12.944,
    viewBox: "0 0 12.942 12.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M12.224,29.26a8.1,8.1,0,0,1-2.568-.411.739.739,0,0,0-.732.175L7.7,30.074a10.44,10.44,0,0,1-4.739-4.56l1.227-1.236a.693.693,0,0,0,.181-.72,8.178,8.178,0,0,1-.41-2.566.721.721,0,0,0-.719-.72H.719a.721.721,0,0,0-.719.72A12.222,12.222,0,0,0,12.224,33.216a.72.72,0,0,0,.718-.719V29.981A.721.721,0,0,0,12.224,29.26Z",
    transform: "translate(0 -20.272)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingcalls);
export default __webpack_public_path__ + "static/media/incomingcalls.7ffc8895.svg";
export { ForwardRef as ReactComponent };